import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {DocumentStatus} from '../../util/uiconstants';

const viewKey = 'FORM_BODY_QUICK_REFERENCE';

export default function formBodyRelatedDocumentsReducer(state = initialstate.formBodyRelatedDocuments, action) {
	switch (action.type) {
		case types.GET_ALL_RELATED_DOCUMENTS_FOR_BODIES: {
			if (action.meta.entityUId) {
				const newState = {
					...state,
					[action.meta.entityUId]: {
						...action.response,
						[action.meta.documentCategoryName]: action.response?.data?.length
					}
				};
				return newState || state;
			}
			return action.response || state;
		}
		case types.GET_RELATED_DOCUMENT_FOR_BODY: {
			if (action.response && action.meta.entityUId && Array.isArray(action.response.data)) {
				const body = state[action.meta.entityUId];

				const data = [];

				if (body && Array.isArray(body.data)) {
					data.push(...body.data);

					const idx = body.data.findIndex((doc) => doc.id === action.meta.documentId);

					if (idx > -1) {
						data.splice(idx, 1, action.response.data[0]);
					} else {
						data.push(action.response.data[0]);
					}
				}

				return {
					...state,
					[action.meta.entityUId]: {
						...body,
						data
					}
				};
			}

			return state;
		}

		case types.RESET_BODY_RELATED_DOCUMENTS: {
			if (action.bodyId) {
				const newState = {
					...state,
					[action.bodyId]: {}
				};
				return newState;
			}
			return state;
		}

		case types.DELETE_DOCUMENT_BY_ID: {
			if (action.viewKey === viewKey && action?.entityUId) {
				const remainingList = state[action.entityUId].data.filter((document) => {
					return document.id !== action.documentId;
				});

				let copy = _.cloneDeep(state);
				copy[action.entityUId].data = remainingList;
				return copy;
			} else {
				return state;
			}
		}
		case types.ASSOCIATE_TASK_DOCUMENTS: {
			if (action?.entityUId && action?.response?.documentId) {
				const updatedDocumentIndex = state[action.entityUId].data.findIndex((document) => {
					return document.id === action.response.documentId;
				});
				let copy = _.cloneDeep(state);
				let updatedDocument = copy[action.entityUId].data[updatedDocumentIndex];
				copy[action.entityUId].data[updatedDocumentIndex] = {
					...updatedDocument,
					...action.response,
					isShared: updatedDocument?.isShared
				};
				return copy;
			}
			return state;
		}
		case types.UPDATE_DOCUMENT: {
			if (action.viewKey === viewKey && action?.entityUId) {
				const updatedDocumentIndex = state[action.entityUId]?.data?.findIndex((document) => {
					return document.id === action.documentId;
				});

				if (!updatedDocumentIndex) {
					return state;
				}
				
				let copy = _.cloneDeep(state);
				let updatedDocument = copy[action.entityUId].data[updatedDocumentIndex];
				copy[action.entityUId].data[updatedDocumentIndex] = {...updatedDocument, ...action.meta.api.data};
				return copy;
			}
			return state;
		}
		case types.ADD_UPLOADING_DOCUMENT: {
			let copy = _.cloneDeep(state);
			const newDoc = action.meta.newDoc;
			const entityUid = newDoc.entityUid;
			if (copy[entityUid] && copy[entityUid].data) {
				let index = copy[entityUid].data.findIndex((doc) => {
					if (doc.filename) {
						return doc.filename.includes(newDoc.filename);
					} else {
						return doc.documentName.includes(newDoc.filename);
					}
				});
				if (index === -1) {
					copy[entityUid].data.unshift(newDoc);
				} else {
					let updatedDocument = copy[entityUid].data[index];
					updatedDocument.fileExt = newDoc.fileExt;
					copy[entityUid].data[index] = updatedDocument;
				}
			}
			return copy;
		}
		// DOCHELPER_ERROR action does no hold any context info, so we have no access to to the triggerer
		// of the action, we have to go with this unless docHelper-middleware gets improved.
		case types.DOCHELPER_ERROR: {
			const result = {...state};

			const documentId = action.error[1];
			Object.entries(result).forEach(([key, value]) => {
				const index = value?.data?.findIndex((document) => document.id === documentId);
				if (index > -1) {
					result[key] = {
						...result[key],
						data: result[key].data.filter((__, i) => i !== index)
					};
				}
			});

			return result;
		}
		case types.POST_RNH_NEW_NOTE: {
			if (action.noteInfo?.viewKey === viewKey && action.noteInfo?.documentId && action.noteInfo?.bodyId) {
				const documentId = action.noteInfo.documentId;
				const bodyId = action.noteInfo.bodyId;
				let bodyDocuments = state[bodyId];

				const updatedDocumentIndex = bodyDocuments?.data?.findIndex((document) => document.id === documentId);

				if (updatedDocumentIndex > -1) {
					const newDocument = {...bodyDocuments.data[updatedDocumentIndex]};
					newDocument.engagementReviewNoteCount = (newDocument.engagementReviewNoteCount || 0) + 1;

					const newData = [...bodyDocuments.data];
					newData[updatedDocumentIndex] = newDocument;

					return {
						...state,
						[bodyId]: {
							...state[bodyId],
							data: newData
						}
					};
				}

				return state;
			} else {
				return state;
			}
		}
		case types.UPDATE_RNH_NOTE_DETAIL: {
			if (
				action.commentData?.viewKey === viewKey &&
				action.commentData?.documentId &&
				action.commentData?.bodyId &&
				action.commentData?.statusIdChanged
			) {
				const documentId = action.commentData.documentId;
				const bodyId = action.commentData.bodyId;
				let bodyDocuments = state[bodyId];

				const updatedDocumentIndex = bodyDocuments?.data?.findIndex((document) => document.id === documentId);

				if (updatedDocumentIndex > -1) {
					const newDocument = {...bodyDocuments.data[updatedDocumentIndex]};
					if (action.commentData.isOpening || action.commentData.isClosing) {
						newDocument.engagementReviewNoteCount =
							(newDocument.engagementReviewNoteCount || 0) + (action.commentData.isOpening ? 1 : -1);
					}

					const newData = [...bodyDocuments.data];
					newData[updatedDocumentIndex] = newDocument;

					return {
						...state,
						[bodyId]: {
							...state[bodyId],
							data: newData
						}
					};
				}

				return state;
			} else {
				return state;
			}
		}
		case 'KRONOS_DOCUMENT_UPLOAD_COMPLETE': {
			if (action.meta.docHelper) {
				if (
					action.meta.docHelper.message.EngagementId === action.meta.docHelper.payload.sourceEngagementId ||
					action.meta.docHelper.message.EngagementId === action.meta.docHelper.payload.engagementId
				) {
					const docHelper = action.meta.docHelper;
					const entityUid = docHelper.payload.entityUid;
					const index = state[entityUid].data.findIndex((doc) => {
						if (doc.filename) {
							return doc.filename.includes(docHelper.message.FileName);
						} else {
							return (
								doc.documentName + '.' + doc.fileExt === docHelper.message.FileName ||
								docHelper.message.FileName === doc.documentName + '.' + doc.fileExt
							);
						}
					});
					let copy = _.cloneDeep(state);
					if (index === -1) {
						let newDocument = docHelper.payload;
						newDocument.filename = docHelper.message.FileName;
						newDocument.documentName = docHelper.message.FileName;
						newDocument.id = docHelper.message.FileId;
						newDocument.documentTypeId = docHelper.payload.documentType;
						newDocument.fileExt = docHelper.payload.fileExt;
						newDocument.documentId = docHelper.message.FileId;
						copy[entityUid].data.unshift(newDocument);
					} else {
						let updatedDocument = copy[entityUid].data[index];
						updatedDocument.documentTypeId = docHelper.payload.documentType;
						updatedDocument.id = docHelper.message.FileId;
						updatedDocument.documentId = docHelper.message.FileId;
						copy[entityUid].data[index] = updatedDocument;
					}
					return copy;
				}
			} else if (action.meta.message) {
				let copy = _.cloneDeep(state);
				let found = undefined;
				Object.values(copy).forEach((body) => {
					if (body && body.data) {
						let index = body.data.findIndex(
							(doc) => action.meta.message.FileName === doc.documentName + '.' + doc.fileExt
						);
						if (index >= 0) {
							found = body.data[index];
							return false;
						}
					}
				});
				if (found) {
					found.id = action.meta.message.FileId;
					found.documentId = action.meta.message.FileId;
				}
				return copy;
			}
			return state;
		}
		case types.REMOVE_TASK_DOCUMENT: {
			const documentState = _.cloneDeep(state);

			const entityDocument = documentState[action.entityUid];

			if (entityDocument && entityDocument.data && entityDocument.data.length > 0) {
				if (action.isDragAndDrop) {
					entityDocument.data = entityDocument.data.filter((doc) => {
						return `${doc.documentName}.${doc.fileExt}` !== action.documentName;
					});
				} else {
					entityDocument.data = entityDocument.data.filter((doc) => doc.filename !== action.documentName);
				}
			}

			return documentState;
		}
		case types.UPDATE_DOCUMENT_ON_ADDING_SIGNOFF: {
			let copy = _.cloneDeep(state);
			if (copy[action.entityUId] && copy[action.entityUId].data && copy[action.entityUId].data.length > 0) {
				let document = copy[action.entityUId].data.find((d) => d.id === action.documentId);
				const newApproval = {
					...action.signOff,
					id: action.signOff?.approvalId ? action.signOff.approvalId : action.signOff.id
				};
				document.approvals = [newApproval, ...document.approvals];
			}
			return copy;
		}
		case types.UPDATE_DOCUMENT_ON_SIGNOFF_REMOVAL: {
			let copy = _.cloneDeep(state);
			if (copy[action.entityUId] && copy[action.entityUId].data && copy[action.entityUId].data.length > 0) {
				let document = copy[action.entityUId].data.find((d) => d.id === action.documentId);
				document.approvals = document.approvals.filter((a) => a.id !== action.approvalId);
			}
			return copy;
		}
		case types.UNLINK_SHARED_DOCUMENT: {
			if (action.viewKey === viewKey && action?.entityUId) {
				const unlinkingDocIndex = state[action.entityUId].data.findIndex((document) => {
					return document.id === action.documentId;
				});
				let copy = _.cloneDeep(state);
				let unlinked = copy[action.entityUId].data[unlinkingDocIndex];
				copy[action.entityUId].data[unlinkingDocIndex] = {
					...unlinked,
					documentStatusId: DocumentStatus.UnlinkInProgress
				};
				return copy;
			}
			return state;
		}
		case types.CHECK_IN_CHECK_OUT_DOCUMENT: {
			if (action && action.responseObj?.data && action.entityUId) {
				var docStatusId =
					action.responseObj.data?.versions &&
					action.responseObj.data.versions.length > 0 &&
					action.responseObj.data.versions.find((version) => version?.isCurrentVersion === true)?.documentStatusId;
				const bodyRelatedDocuments = _.cloneDeep(state[action.entityUId].data);
				bodyRelatedDocuments.find((document) => document.id === action.documentId).documentStatusId = docStatusId;
				return {
					...state,
					[action.entityUId]: {
						...state[action.entityUId],
						data: bodyRelatedDocuments
					}
				};
			}
			return state;
		}
		default:
			return state;
	}
}
